export interface MapState {
  mapLatitude?: string | undefined;
  setMapLatitude: (mapLatitude: string | undefined) => void;
  mapLongitude?: string | undefined;
  setMapLongitude: (mapLongitude: string | undefined) => void;
  mapSearchRadius?: number | undefined;
  setMapSearchRadius: (mapSearchRadius: number | undefined) => void;
}

export enum StoreKeys {
  MAP_LATITUDE = 'mapLatitude',
  SET_MAP_LATITUDE = 'setMapLatitude',
  MAP_LONGITUDE = 'mapLongitude',
  SET_MAP_LONGITUDE = 'setMapLongitude',
  MAP_SEARCH_RADIUS = 'mapSearchRadius',
  SET_MAP_SEARCH_RADIUS = 'setMapSearchRadius',
}

export const initialState = {
  [StoreKeys.MAP_LATITUDE]: undefined,
  [StoreKeys.MAP_LONGITUDE]: undefined,
  [StoreKeys.MAP_SEARCH_RADIUS]: undefined,
};
